import * as req from 'api/actions';
import * as c from './constant';


// E2E API
export const getTotalStatsE2E = (payload, callback) =>
  req.item(
    c.GET_TOTAL_STATS_E2E,
    '/api/v1/administrators/bpls_dashboard/statistics',
    payload,
    callback
  );

  export const getGraphStatsE2E = (
    payload,
    callback
  ) =>
    req.list(
      c.GET_GRAPH_STATS_E2E,
      '/api/v1/administrators/dashboard/graph',
      payload,
      callback
    );
  
  
  export const getMapDataE2E = (
    payload,
    callback
  ) =>
    req.list(
      c.GET_MAP_DATA_E2E,
      '/api/v1/bpls/administrator/business_locations',
      payload,
      callback
    );

// Eboss API
export const getTotalStats = (payload, callback) =>
  req.item(
    c.GET_TOTAL_STATS,
    '/api/v1/administrators/business_permit_dashboard/statistics',
    payload,
    callback
  );

export const getGraphStats = (
  payload,
  callback
) =>
  req.list(
    c.GET_GRAPH_STATS,
    '/api/v1/administrators/dashboard/graph',
    payload,
    callback
  );


export const getMapData = (
  payload,
  callback
) =>
  req.list(
    c.GET_MAP_DATA,
    'api/temp/administrators/transaction_histories/businesses/location',
    payload,
    callback
  );

